import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "reactstrap";
import { getBranches } from "../../services/branchService";
import { toast } from "react-toastify";
import AddAwardType from "./AddAwardType";

import EditAwardType from "./EditAwardType";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  ButtonGroup,
  Breadcrumb,
  Form,
} from "@themesberg/react-bootstrap";

import SpinDiv from "../components/SpinDiv";
import { addAwardTypes, getAwardTypes } from "../../services/awardTypeService";
export class AwardTypeIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      award_types: [],
      value:"",
      total: 0,
    }
  }

  componentDidMount() {
   this.getAwardTypes();
  }
  

  showToast = (msg) => {
    toast(<div style={{ padding: 20, color: "green" }}>{msg}</div>);
  };
  getAwardTypes = () => {

    const { page, rows, search} = this.state;
    this.setState({ loading: true });
    getAwardTypes({ page, rows, search }).then(
      (res) => {
        this.setState({
          loading: false,
          award_types:res.award_types.data,
          total:res.award_types.total
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

  

  toggleAddAwardType = () => {
    this.setState({ addAwardTypes: !this.state.addAwardTypes });
  };
  
  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  toggleEdit = (editAwardType) => {
    this.setState({ editAwardType });
  };

  
  
  render() {
    const {
      award_types,
      total,
      addAwardTypes,
      editAwardType,
      rows,
      search,
      loading,
      filtering
    } = this.state;
    return (
      <>
      
        {addAwardTypes && (
          <AddAwardType
            saved={this.getAwardTypes}
            addAwardTypes={addAwardTypes}
            toggle={() => this.setState({ addAwardTypes: null })}
          />
        )}

        {editAwardType && (
          <EditAwardType
            saved={this.getAwardTypes}
            editAwardType={editAwardType}
            toggle={() => this.setState({ editAwardType: null })}
          />
        )}

       

        {loading && <SpinDiv text={"Loading..."} />}
        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#products">products</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="btn-toolbar mb-2 mb-md-0">
                <ButtonGroup>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => this.toggleAddAwardType()}
                  >
                    Create Award Types
                  </Button>

                

                
                  <Button variant="outline-primary" size="sm"  
                  onClick={() => {this.props.history.push('/awards')}}

                  >
                    Awards
                  </Button>
                  
                  {/* <Button variant="outline-primary" size="sm">
                    Export
                  </Button> */}
                </ButtonGroup>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="7">
            <h6>Award Types({total})</h6>
           
          </Col>
          
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                id="show"
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                value={search}
                onChange={(e) => this.onChange(e.target.value, "search")}
                autoFocus
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.getAwardTypes();
                    this.setState({
                      search: "",
                    });
                  }
                }}
              />
              <Button
                className="btn-icon btn-2"
                color="secondary"
                style={{ maxHeight: 45 }}
                size="sm"
                onClick={this.getAwardTypes}
              >
                <i className="fa fa-search" />
              </Button>
            </div>
          </Col>
        </Row>
        
        <Card border="light" className="shadow-sm mb-4">
          
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0">Award Type</th>
                  <th className="border-0">Action</th>
                </tr>
              </thead>
              <tbody>
            
                {award_types.map((award_type, key) => {
                  return (
                    <tr key={key}>
                      <td>{award_type.name}</td>
                      <td>
                            <Button
                              color="secondary"
                              onClick={() => this.toggleEdit(award_type)}
                              size="sm"
                            >
                              Edit
                            </Button>
                      </td>
                      
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default AwardTypeIndex;
